import { render } from "./DashboardCharts.vue?vue&type=template&id=1d372090"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__